import { Suspense } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { WMSTileLayer } from "react-leaflet";
import { useCaseShapeSelectionLayers } from "src/hooks";
import type { FeatureSelectionLayer } from "src/types";

interface Props {
  selectedLayer: FeatureSelectionLayer | null;
  runYear: number;
}

export function CaseSelectFeatureLayer(props: Props) {
  return (
    <ErrorBoundary fallback={null}>
      <Suspense fallback={null}>
        <LoadData {...props} />
      </Suspense>
    </ErrorBoundary>
  );
}

function LoadData(props: Props) {
  const { selectedLayer, runYear } = props;
  const { data: layers } = useCaseShapeSelectionLayers(runYear);
  const layer = selectedLayer || layers?.at(0);

  if (!layer) return null;

  return (
    <WMSTileLayer
      key={`case-select-feature-layer-${layer.id}`}
      id={`case-select-feature-layer-${layer.id}`}
      zIndex={9999}
      url="/geoserver/wms"
      opacity={1}
      layers={layer?.geoserverLayer}
      format="image/png"
      transparent
      // @ts-ignore
      tiled={true}
    />
  );
}
